import API from "../axiosConfig";

export const getVehicleUuid = async () => {
  try {
    const response = await API.get("/vehicle-uuid");
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicles:", error);
    throw error;
  }
};

export const getVehicleUuidUnused = async () => {
  try {
    const response = await API.get("/vehicle-uuid/unused");
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicles:", error);
    throw error;
  }
};

export const generateVehicleUuid = async () => {
  try {
    const response = await API.get(`/vehicle-uuid/generate`);
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicle:", error);
    throw error;
  }
};
